import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { server } from './global.service';
import { server_ip } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

var header = {
  Accept: "application/json",
  "Content-Type": "application/json",
}


@Injectable({
  providedIn: 'root'
})


export class fund_service {
  constructor(private backend: server,public http: HttpClient) { }

  search(data):Observable<any> {
    return this.backend.post(server_ip + "/searchFunds?page="+data.page_number+"&size="+data.size+"&isDownload="+data.isDownload, data, header)
  }
  
  getModuleconfig(key, module):Observable<any>{
    return  this.backend.get(server_ip + "/getModuleConfig?key="+key+"&module="+module);
  }
    
  getFundById(id,migratedFlag):Observable<any> {
    return this.backend.get(server_ip + "/getFundById?id="+id+"&migratedFlag="+migratedFlag)
  }

  get_fund_master():Observable<any>{
    return this.backend.get(server_ip+"/statusMaster");
  }

  getAPIFaultCodes(reportType):Observable<any>{
    return this.backend.get(server_ip+"/apiFaultCodes?reportType="+reportType);
  }

  transaction(transactionData):Observable<any> {
    return this.backend.get(server_ip + "/getTransactions?page="+transactionData.page_number+"&size="+transactionData.size+ "&filter="+transactionData.filter + "&isDownload="+transactionData.isDownload + "&migratedSource="+transactionData?.migratedSrc)
  }

  sendOtpForFundTransaction(data):Observable<any> {
    return this.backend.post(server_ip + "/send-approval-otp", data, header);
  }

  validateOTP(data, currentStatus, migratedSrc):Observable<any>{
    return this.backend.post(server_ip + "/validate-aprroval-otp?approvalStatus="+currentStatus+"&migratedSource="+migratedSrc, data, header)

  }

  transByReq(data):Observable<any>{
    return this.backend.post(server_ip + "/getTransactionByReqNo",data, header)
  }

  // approvedTransaction(data,status):Observable<any>{
  //   return this.backend.post(server_ip + "/approveRejectTransactions?approvalStatus="+status, data, header)
  // }
  customerByCustId(customerCode):Observable<any>{
    // return this.backend.get(server_ip + "/getCustomerByCustId?custId="+customerCode)
    let response = {
      statuCode: 200,
      result: {
        customerCode: customerCode,
        migratedFlag: true
      }
    }
    return of(response)
  }

  view_TPH_2MFA_Result(request_no):Observable<any>{
    return this.backend.get(server_ip + "/getTransactionDetails/"+request_no);
  }
}
